<template>
	<v-list-item class="mb-0 justify-space-between pl-3">
		<img src="/logo.png" style="float: right;max-width: 100px;max-height: 50px;" />
		<v-list-item-content class="pl-2">
			<v-list-item-title class="text-h3">
				<strong class="mr-1 font-weight-black">جت</strong>
				&nbsp;
				<span class="primary--text">اقساط</span>
				<div class="text-h6">پنل سوپر ادمین</div>
				<user-full-name :hideCustomer="true" />
			</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import UserFullName from '@/components/Username'
	import NationalCode from '@/components/NationalCode'

	export default {
		name: 'DefaultDrawerHeader',
		components: {
			UserFullName,
			NationalCode,
		},
		computed: {
			version: get('app/version'),
		},
	}
</script>
